import { CheckIcon } from '@/components/privatleasing/CheckIcon';
import { m } from 'motion/react';
import { FC } from 'react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

interface FeatureItem {
  text: string;
}

interface GreyListBoxProps {
  title: string;
  underTitle?: string;
  items: FeatureItem[];
  backgroundColor?: string;
  className?: string;
}

const GreyListbox: FC<GreyListBoxProps> = ({
  title,
  underTitle,
  items,
  backgroundColor = 'bg-gray-100',
  className = '',
}) => {
  return (
    <m.section
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className={`${backgroundColor} ${className} p-4`}
    >
      <m.h2 variants={itemVariants} className="font-semibold text-lg mb-0">
        {title}
      </m.h2>
      {underTitle && (
        <m.p variants={itemVariants} className="mb-4">
          {underTitle}
        </m.p>
      )}
      <div className="ml-5">
        {items.map((item, idx) => (
          <m.div
            key={idx}
            variants={itemVariants}
            className="flex items-baseline mb-2"
          >
            <div className="relative flex-shrink-0">
              <CheckIcon width={24} height={24} color="black" strokeWidth={3} />
            </div>
            <p className="ml-2">{item.text}</p>
          </m.div>
        ))}
      </div>
    </m.section>
  );
};

export default GreyListbox;
